import { useEffect } from "react";
import { useLocation } from "wouter";
import { pushNavEntry, pushTapEntry, cleanPath } from "@/lib/navTrail";

export function useNavTrailRecorder() {
  const [location] = useLocation();

  useEffect(() => {
    const search = typeof window !== "undefined" ? window.location.search : "";
    pushNavEntry(cleanPath(`${location}${search}`));
  }, [location]);

  useEffect(() => {
    const handler = (e: PointerEvent) => pushTapEntry(e);
    document.addEventListener("pointerdown", handler, { passive: true, capture: true });
    return () => document.removeEventListener("pointerdown", handler, true);
  }, []);
}
